import _ from 'lodash';
import nextArrow from '../assets/images/icons/carouselNextGray.svg';
import prevArrow from '../assets/images/icons/carouselPrevGray.svg';
import { ReactComponent as DayShiftIcon } from '../assets/images/icons/darken/dayShift.svg';
import { ReactComponent as MidShiftIcon } from '../assets/images/icons/darken/midShift.svg';
import { ReactComponent as NightShiftIcon } from '../assets/images/icons/darken/nightShift.svg';
import { ReactComponent as PlaneIcon } from '../assets/images/icons/darken/travel.svg';
import { ReactComponent as PermanentIcon } from '../assets/images/icons/darken/permanent.svg';
import { ReactComponent as LocalContractIcon } from '../assets/images/icons/darken/icon-local.svg';
import { ReactComponent as IRPIcon } from '../assets/images/icons/darken/icon-irp.svg';
import { ReactComponent as PerDiemIcon } from '../assets/images/icons/darken/icon-perdiem.svg';

import { getSpecialties } from '../redux/slices/specialties';
import { getRecruiterById } from '../redux/slices/recruiters';
import { Config } from '../config';
import SuperFetch from './superFetch';

export const fetcher = (...args) => {
  const headers = {
    Accept: 'application/json, text/plain, */*',
    'Content-Type': 'application/json',
  };

  try {
    const token = localStorage.getItem('token');

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
  } catch (error) {
    console.log(error);
  }

  const options = {
    method: 'get',
    headers,
  };

  return fetch(...args, options).then((res) => res.json());
};

export const NextArrow = (props) => {
  const { className, style, onClick } = props;
  return (
    <div
      className={`${className} carousel-next`}
      style={{ ...style }}
      onClick={onClick}
    >
      <img src={nextArrow} />
    </div>
  );
};

export const PrevArrow = (props) => {
  const { className, style, onClick } = props;
  return (
    <div
      className={`${className} carousel-prev`}
      style={{ ...style }}
      onClick={onClick}
    >
      <img src={prevArrow} />
    </div>
  );
};

export const sortOptions = {
  domestic: [
    {
      value: 'start_time',
      label: 'Start Date',
      order_by: 'start_time',
      order: 'asc',
      query_string: 'start_time_asc',
    },
    {
      value: 'rate',
      label: 'Highest Pay',
      order_by: 'rate',
      order: 'desc',
      query_string: 'rate_desc',
    },
    {
      value: 'beds_desc',
      label: 'Bed Size (High to Low)',
      order_by: 'beds',
      order: 'desc',
      query_string: 'beds_desc',
    },
    {
      value: 'beds_asc',
      label: 'Bed Size (Low to High)',
      order_by: 'beds',
      order: 'asc',
      query_string: 'beds_asc',
    },
    {
      value: 'shift_asc',
      label: 'Shift (Day, Mid, Night)',
      order_by: 'shift',
      order: 'asc',
      query_string: 'shift_asc',
    },
    {
      value: 'assignment_length_asc',
      label: 'Assignment Length (Shortest)',
      order_by: 'assignment_length',
      order: 'asc',
      query_string: 'assignment_length_asc',
    },
    {
      value: 'assignment_length_desc',
      label: 'Assignment Length (Longest)',
      order_by: 'assignment_length',
      order: 'desc',
      query_string: 'assignment_length_desc',
    },
    {
      value: 'pay_packages',
      label: 'Multiple Pay Packages',
      order_by: 'pay_packages',
      order: 'desc',
      query_string: 'pay_packages_desc',
    },
    /*{
      value: 'posted_desc',
      label: 'New Assignment',
      order_by: 'posted',
      order: 'desc',
      query_string: 'posted_desc'
    },*/
  ],
  permanent: [
    /*{
      value: 'posted_desc',
      label: 'New Assignment',
      order_by: 'posted',
      order: 'desc',
      query_string: 'posted_desc'
    },*/
    {
      value: 'rate',
      label: 'Highest Pay',
      order_by: 'rate',
      order: 'desc',
      query_string: 'rate_desc',
    },
    {
      value: 'beds_desc',
      label: 'Bed Size (High to Low)',
      order_by: 'beds',
      order: 'desc',
      query_string: 'beds_desc',
    },
    {
      value: 'beds_asc',
      label: 'Bed Size (Low to High)',
      order_by: 'beds',
      order: 'asc',
      query_string: 'beds_asc',
    },
    {
      value: 'shift_asc',
      label: 'Shift (Day, Mid, Night)',
      order_by: 'shift',
      order: 'asc',
      query_string: 'shift_asc',
    },
    {
      value: 'pay_packages',
      label: 'Multiple Pay Packages',
      order_by: 'pay_packages',
      order: 'desc',
      query_string: 'pay_packages_desc',
    },
  ],
  local: [
    /*{
      value: 'posted_desc',
      label: 'New Assignment',
      order_by: 'posted',
      order: 'desc',
      query_string: 'posted_desc'
    },*/
    {
      value: 'rate',
      label: 'Highest Pay',
      order_by: 'rate',
      order: 'desc',
      query_string: 'rate_desc',
    },
    {
      value: 'beds_desc',
      label: 'Bed Size (High to Low)',
      order_by: 'beds',
      order: 'desc',
      query_string: 'beds_desc',
    },
    {
      value: 'beds_asc',
      label: 'Bed Size (Low to High)',
      order_by: 'beds',
      order: 'asc',
      query_string: 'beds_asc',
    },
    {
      value: 'shift_asc',
      label: 'Shift (Day, Mid, Night)',
      order_by: 'shift',
      order: 'asc',
      query_string: 'shift_asc',
    },
    {
      value: 'assignment_length_asc',
      label: 'Assignment Length (Shortest)',
      order_by: 'assignment_length',
      order: 'asc',
      query_string: 'assignment_length_asc',
    },
    {
      value: 'assignment_length_desc',
      label: 'Assignment Length (Longest)',
      order_by: 'assignment_length',
      order: 'desc',
      query_string: 'assignment_length_desc',
    },
    {
      value: 'pay_packages',
      label: 'Multiple Pay Packages',
      order_by: 'pay_packages',
      order: 'desc',
      query_string: 'pay_packages_desc',
    },
  ],
  irp: [
    /*{
      value: 'posted_desc',
      label: 'New Assignment',
      order_by: 'posted',
      order: 'desc',
      query_string: 'posted_desc'
    },*/
    {
      value: 'rate',
      label: 'Highest Pay',
      order_by: 'rate',
      order: 'desc',
      query_string: 'rate_desc',
    },
    {
      value: 'beds_desc',
      label: 'Bed Size (High to Low)',
      order_by: 'beds',
      order: 'desc',
      query_string: 'beds_desc',
    },
    {
      value: 'beds_asc',
      label: 'Bed Size (Low to High)',
      order_by: 'beds',
      order: 'asc',
      query_string: 'beds_asc',
    },
    {
      value: 'shift_asc',
      label: 'Shift (Day, Mid, Night)',
      order_by: 'shift',
      order: 'asc',
      query_string: 'shift_asc',
    },
    {
      value: 'pay_packages',
      label: 'Multiple Pay Packages',
      order_by: 'pay_packages',
      order: 'desc',
      query_string: 'pay_packages_desc',
    },
  ],
  perDiem: [
    /*{
      value: 'posted_desc',
      label: 'New Assignment',
      order_by: 'posted',
      order: 'desc',
      query_string: 'posted_desc'
    },*/
    {
      value: 'rate',
      label: 'Highest Pay',
      order_by: 'rate',
      order: 'desc',
      query_string: 'rate_desc',
    },
    {
      value: 'beds_desc',
      label: 'Bed Size (High to Low)',
      order_by: 'beds',
      order: 'desc',
      query_string: 'beds_desc',
    },
    {
      value: 'beds_asc',
      label: 'Bed Size (Low to High)',
      order_by: 'beds',
      order: 'asc',
      query_string: 'beds_asc',
    },
    {
      value: 'shift_asc',
      label: 'Shift (Day, Mid, Night)',
      order_by: 'shift',
      order: 'asc',
      query_string: 'shift_asc',
    },
    {
      value: 'pay_packages',
      label: 'Multiple Pay Packages',
      order_by: 'pay_packages',
      order: 'desc',
      query_string: 'pay_packages_desc',
    },
  ],
};

export const DropdownSelectAsyncCustomStyles = {
  valueContainer: (provided, state) => ({
    ...provided,
    textOverflow: 'ellipsis',
    maxWidth: '90%',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    fontSize: '13px',
    marginTop: '-2px',
    color: '#303030',
    display: 'flex',
    padding: '2px 2px',
    marginLeft: '18px',
    boxShadow: 'none',
    border: 'none',
  }),
  indicatorsContainer: (provided, { data, isFocused }) => ({
    ...provided,
    height: 30,
  }),
  placeholder: (provided, { data, isFocused }) => ({
    ...provided,
    position: 'relative',
    transform: null,
    color: '#A2A5AC',
    fontSize: '13px',
  }),
  menu: (css) => ({
    ...css,
    borderRadius: '6px',
    backgroundColor: '#FFFFFF',
  }),
  option: (provided, { data, isDisabled, isFocused, isSelected }) => {
    return {
      ...provided,
      color: '#303030',
      cursor: 'pointer',
      padding: '5px 10px',
      backgroundColor: isDisabled
        ? null
        : isSelected
        ? isFocused
          ? '#EDEDED'
          : 'transparent'
        : isFocused
        ? '#EDEDED'
        : null,
    };
  },
  singleValue: (provided, state) => {
    const opacity = state.isDisabled ? 0.5 : 1;
    const transition = 'opacity 300ms';
    return { ...provided, opacity, transition };
  },
  multiValue: (provided, state) => {
    const opacity = state.isDisabled ? 0.5 : 1;
    const transition = 'opacity 300ms';
    return {
      ...provided,
      width: 'fit-content',
      background: '#DFDFDF',
      borderRadius: '11px',
      color: '#303030',
      opacity,
      transition,
      ':hover': {
        borderColor: '@DFDFDF',
      },
    };
  },
  control: (provided) => ({
    ...provided,
    borderRadius: '0',
  }),
  multiValueLabel: (provided, state) => {
    return { ...provided, padding: '3px 7px' };
  },
};

export const getRandom = () => {
  return Math.random().toString(36).substring(7);
};

export const priceFormat = (number, totalDecimal = 2) => {
  return !number
    ? 0.0
    : parseFloat(number)
        .toFixed(totalDecimal)
        .replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
};

export const goToTop = () => {
  window.scrollTo(0, 0);
};

export const getProfession = (typeJob) => {
  const config = {
    1: 'RN',
    2: 'Allied',
    3: 'LVN/LPN',
    5: 'Public Health',
    6: 'CNA',
  };

  return config[typeJob] || false;
};

export const getIconShift = (shift, classname = '') => {
  const config = {
    Day: <DayShiftIcon className={`icon ${classname}`} />,
    Mid: <MidShiftIcon className={`icon ${classname}`} />,
    Night: <NightShiftIcon className={`icon ${classname}`} />,
    Rotating: <DayShiftIcon className={`icon ${classname}`} />,
    Flex: <DayShiftIcon className={`icon ${classname}`} />,
  };

  return config[shift] || false;
};

export const getTypeJobJob = (typeJob, jobId, size = null) => {
  const config = {
    1: (
      <PlaneIcon
        className="icon-black"
        data-tip
        data-for={`icon-${jobId}`}
        width={size}
        height={size}
      />
    ),
    2: (
      <PermanentIcon
        className="icon-black"
        data-tip
        data-for={`icon-${jobId}`}
        width={size}
        height={size}
      />
    ),
    3: (
      <LocalContractIcon
        className="icon-black"
        data-tip
        data-for={`icon-${jobId}`}
        width={size}
        height={size}
      />
    ),
    4: (
      <IRPIcon
        className="icon-black"
        data-tip
        data-for={`icon-${jobId}`}
        width={size}
        height={size}
      />
    ),
    5: (
      <PerDiemIcon
        className="icon-black"
        data-tip
        data-for={`icon-${jobId}`}
        width={size}
        height={size}
      />
    ),
  };

  return config[typeJob] || false;
};

export const getTypeJobText = (typeJob) => {
  const config = {
    1: 'Travel Assignment',
    2: 'Permanent Job',
    3: 'Local',
    4: 'Internal Resource Pool',
    5: 'Per Diem',
    6: 'Locum Tenens',
  };

  return config[typeJob] || false;
};

export const getTypeJob = (typeJob) => {
  const config = {
    domestic: 1,
    permanent: 2,
    local: 3,
    irp: 4,
    perDiem: 5,
    locumTenens: 6,
  };

  return config[typeJob] || false;
};

const getTypeJobInverse = (typeJob) => {
  const config = {
    1: 'domestic',
    2: 'permanent',
    3: 'local',
    4: 'irp',
    5: 'perDiem',
    6: 'locumTenens',
  };

  return config[typeJob] || false;
};

export const getPaymentTypeAbbr = (paymentType) => {
  const config = {
    weekly: 'wk',
    yearly: 'yr',
    hourly: 'hr',
    shift: 'shift',
  };

  return config[paymentType] || false;
};

export const getExperienceLevel = (expLevel) => {
  const config = {
    1: 'Entry Level',
    2: 'Residency Program',
    3: 'Experienced',
    4: 'Leadership',
  };

  return config[expLevel] || false;
};

const getDropdownsValue = (dataArray, key) => {
  let values;
  if (!dataArray || dataArray.length < 0) return false;

  if (typeof dataArray[0] === 'object') {
    dataArray = dataArray.map((item) => item[key]);
  }

  values = dataArray.join(', ');
  return values;
};

export const parseFilters = (filters) => {
  let queryString = '';

  const omit = ['perPage', 'sort_dropdown', 'initialRequest', 'fromHome'];
  for (let key in filters) {
    if (filters.hasOwnProperty(key) && !omit.includes(key)) {
      let value,
        valueAlt = '';

      if (filters[key]) {
        if (key === 'typeJob') {
          value = getTypeJob(filters[key]);
          key = 'job_type';
        } else if (key === 'date') {
          const myDate = new Date(filters[key]);
          value = Math.floor(
            Date.UTC(
              myDate.getFullYear(),
              myDate.getMonth(),
              myDate.getDate()
            ) / 1000
          );
        } else if (key === 'shift') {
          if (filters[key].length > 0) {
            value = `${filters[key]}, Flex, Rotating`;
          }
        } else if (Array.isArray(filters[key])) {
          value = getDropdownsValue(filters[key], 'value');
          if (key === 'location') {
            valueAlt = getDropdownsValue(filters[key], 'urlValue');
          }
        } else if (typeof filters[key] === 'object') {
          value = filters[key].value;
        } else {
          value = filters[key];
        }

        if (value) {
          queryString += `${key}=${value}&`;
        }

        if (key === 'location') {
          queryString += `searched_location=${valueAlt}&`;
        }
      }
    }
  }

  return queryString;
};

export const hasValidQueryString = (filters) => {
  let obj = {};
  for (let key in filters) {
    if (filters.hasOwnProperty(key)) {
      if (filters[key]) {
        if (Array.isArray(filters[key]) && filters[key].length > 0) {
          const value = filters[key];
          if (key === 'specialty_ids' || key === 'specialities') {
            key = 'specialty_ids';
          }
          obj[key] = value;
        } else if (!Array.isArray(filters[key])) {
          obj[key] = filters[key];
        }
      }
    }
  }

  return obj;
};

export const getSpecialtiesAsync = async (values, profession) => {
  return await Promise.all(
    values.map(async (item) => {
      return await getSpecialties(item.trim().toLowerCase(), profession);
    })
  );
};

const getRecruitersAsync = async (values) => {
  return await Promise.all(
    values.map(async (item) => {
      return await getRecruiterById(item);
    })
  );
};

// Asynchronous thunk action
export const getAgencies = async (id) => {
  if (!id) return;

  try {
    const url = `${Config.WAPI_URL}/agency/${id}`;
    const response = await SuperFetch.get(url);

    if (response.data.length > 0) {
      return {
        value: response.data[0].id,
        label: response.data[0].name,
      };
    }
  } catch (error) {
    console.log(error);
  }
};

const getAgenciesAsync = async (values) => {
  return await Promise.all(
    values.map(async (item) => {
      return await getAgencies(item.trim());
    })
  );
};

// Asynchronous thunk action
export const getHospitals = async (id) => {
  if (!id) return;

  try {
    const url = `${Config.WAPI_URL}/facility/${id}`;
    const response = await SuperFetch.get(url);

    if (response.data) {
      return {
        value: response.data.id,
        label: response.data.name,
      };
    }
  } catch (error) {
    console.log(error);
  }
};

export const getHospitalsByName = async (value) => {
  if (!value) return;

  try {
    const url = `${Config.WAPI_URL}/jobs/suggestion/hospital/?text=${value}`;
    const response = await SuperFetch.get(url);
    if (response.data) {
      return {
        value: response.data[0].id,
        label: response.data[0].name,
      };
    }
  } catch (error) {
    console.log(error);
  }
};

export const getHospitalsAsync = async (values) => {
  return await Promise.all(
    values.map(async (item) => {
      return await getHospitals(item.trim());
    })
  );
};

export const getHospitalsAsyncByName = async (values) => {
  return await Promise.all(
    values.map(async (item) => {
      return await getHospitalsByName(item.trim());
    })
  );
};

export const parseQueryStringToFilters = async (filters) => {
  let obj = {};
  const isDropdown = [
    'location',
    'specialty_ids',
    'specialties',
    'profession_id',
    'agency',
    'hospital',
    'recruiter_ids',
  ];
  const isCheckbox = ['shift', 'assignment_length'];
  const omit = ['redirection', 'searched_location'];

  for (let key in filters) {
    if (filters.hasOwnProperty(key) && !omit.includes(key)) {
      let data;
      if (isDropdown.includes(key)) {
        if (key === 'location') {
          data = [];
          const value = filters[key][0];

          const values = value.split(',');
          values.forEach((item) => {
            data = [
              ...data,
              {
                value: item.trim().replace('**', ', '),
                label: item.trim().replace('**', ', '),
                urlValue: item.trim(),
              },
            ];
          });
        } else if (key === 'specialty_ids' || key === 'specialities') {
          data = [];
          const value = filters[key][0];
          const values = value.split(',');
          const profession = filters['profession_id'] || '';
          data = await getSpecialtiesAsync(values, profession);
          key = 'specialty_ids';
        } else if (key === 'recruiter_ids') {
          data = [];
          const value = filters[key][0];
          const values = value.split(', ');
          data = await getRecruitersAsync(values);
        } else if (key === 'agency') {
          data = [];
          const value = filters[key][0];
          const values = value.split(', ');
          data = await getAgenciesAsync(values);
        } else if (key === 'hospital') {
          data = [];
          const value = filters[key][0];
          const values = value.split(', ');

          data = await getHospitalsAsync(values);
        } else if (key === 'profession_id') {
          data = { value: filters[key], label: getProfession(filters[key]) };
        }
      } else if (isCheckbox.includes(key)) {
        data = [];
        const value = filters[key][0];

        const values = value.split(',');
        values.forEach((item) => {
          data = [
            ...data,
            key === 'assignment_length' ? +item.trim() : item.trim(),
          ];
        });
      } else {
        if (key === 'date') {
          data = Math.floor(filters[key] * 1000);
        } else if (key === 'job_type') {
          data = getTypeJobInverse(filters[key]);
          key = 'typeJob';
        } else if (key === 'order_by') {
          data = sortOptions[getTypeJobInverse(filters['job_type'])].filter(
            (item) =>
              item.query_string === `${filters[key]}_${filters['order']}`
          );
          key = 'sort_dropdown';
        } else {
          data = filters[key];
        }
      }

      obj[key] = data;

      if (key === 'sort_dropdown') {
        obj['order_by'] = data[0].order_by;
        obj['order'] = data[0].order;
      }
    }
  }

  return obj;
};

export const paramsToUrl = (filters, page = 1, omitFromHomeParam = true) => {
  let queryString = `page=${page}&`;

  const omit = ['perPage', 'sort_dropdown', 'page', 'initialRequest', 'fromHome'];

  for (let key in filters) {
    if (filters.hasOwnProperty(key) && (!omit.includes(key) || (omitFromHomeParam && key === 'fromHome'))) {
      let value = ``;

      if (filters[key]) {
        if (key === 'typeJob') {
          value = getTypeJob(filters[key]);
          key = 'job_type';
        } else if (key === 'date') {
          value = Math.floor(new Date(filters[key]).getTime() / 1000);
        } else if (Array.isArray(filters[key])) {
          if (key === 'location') {
            value = getDropdownsValue(filters[key], 'urlValue');
          } else if (
            key === 'recruiter_ids' ||
            key === 'agency' ||
            key === 'hospital'
          ) {
            value = getDropdownsValue(filters[key], 'value');
          } else {
            value = getDropdownsValue(filters[key], 'label');
          }
        } else if (typeof filters[key] === 'object') {
          value = filters[key].value;
        } else {
          value = filters[key];
        }

        if (value) {
          queryString += `${key}=${value}&`;
        }
      }
    }
  }

  return `${queryString}`;
};

export const makePPODRequestUrl = (filters) => {
  let queryString = 'is_supervisor=0&';

  const omit = ['perPage', 'sort_dropdown', 'initialRequest', 'fromHome'];

  for (let key in filters) {
    if (filters.hasOwnProperty(key) && !omit.includes(key)) {
      let value = '';

      if (key === 'typeJob') {
        value = getTypeJob(filters[key]);
        key = 'job_type';
      } else if (key === 'date') {
        const myDate = filters[key] ? new Date(filters[key]) : new Date();
        value = Math.floor(
          Date.UTC(myDate.getFullYear(), myDate.getMonth(), myDate.getDate()) /
            1000
        );
        key = 'start_date';
      } else if (key === 'rate') {
        value = filters[key] || 500;
        key = 'min_rate';
      } else if (key === 'profession_id') {
        value = filters[key]?.value || 1;
      } else if (Array.isArray(filters[key]) || key === 'specialty_ids') {
        if (key === 'location') {
          value = getDropdownsValue(filters[key], 'urlValue');
        } else if (key === 'recruiter_ids') {
          value = getDropdownsValue(filters[key], 'value');
        } else {
          value = getDropdownsValue(filters[key], 'label');
        }
        if (key === 'specialty_ids') {
          key = 'specialities';
        }
      } else if (typeof filters[key] === 'object') {
        if (filters[key]) {
          value = filters[key].value;
        }
      } else {
        value = filters[key];
      }

      queryString += `${key}=${value || ''}&`;
    }
  }
  return queryString;
};

export const removeURLParameter = (url, parameter) => {
  //prefer to use l.search if you have a location/link object
  const urlParts = url.split('?');
  if (urlParts.length >= 2) {
    const prefix = encodeURIComponent(parameter) + '=';
    const pars = urlParts[1].split(/[&;]/g);

    //reverse iteration as may be destructive
    for (var i = pars.length; i-- > 0; ) {
      //idiom for string.startsWith
      if (pars[i].lastIndexOf(prefix, 0) !== -1) {
        pars.splice(i, 1);
      }
    }

    return urlParts[0] + (pars.length > 0 ? pars.join('&') : '');
  }
  return url;
};

export const getFullProfessionLabel = (professionId) => {
  const config = {
    1: 'Travel Assignment',
    2: 'Permanent',
    3: 'Local',
    4: 'Internal Resource Pool',
    5: 'Per Diem',
  };

  return config[professionId] || config[1];
}

export const formatPayRate = (amount, decimals = 2) => {
  if (!amount) {
    return 0;
  }

  return parseFloat(amount.toFixed(decimals));
}

export const handleFriendlyUrl = (parts) => {
  let obj = {};

  for (let key in parts) {
    let value = '';

    if (parts.hasOwnProperty(key)) {
      if (key === 'typeJob') {
        value = parts[key];
      } else if (key === 'location' && parts[key]?.name) {
        const city = parts[key]?.name?.trim().replace('**', ', ');
        const state = parts[key]?.state?.trim();
        const fullCity = `${city}${state ? `, ${state}`: '' }`;

        value = [
          {
            value: `${fullCity}` ,
            label: `${fullCity}` ,
            urlValue: `${state ? `${city}**${state}` : `${city}`}`,
          },
        ];

      } else if (key === 'profession') {
        value = parts[key].id;
        key = 'profession_id';

      } else if (key === 'specialty') {
        value =  [{
          value: parts[key].id,
          label: parts[key].name,
          fakeLabel: parts[key].name,
        }];
        key = 'specialty_ids';
      } else if (key === 'agency') {
        value =  [{
          value: parts[key].id,
          label: parts[key].name,
        }];
      }

      obj[key] = value;
    }
  }

  return obj;
};

export const getUpdatedJobTypesData = (jobTypes) => {
  return jobTypes.map((item) => {
    // Renaming IRP to Internal Resource Pool
    if (item.job_type_name === 'IRP') {
      return { ...item, job_type_name: 'Internal Resource Pool' };
    }
    return item;
  })
    .filter((item) => item.job_type_name !== 'Locum Tenens');
}

export const markAsInterestedButton = ($el) => {
  $el.html('<img src="/images/icons/checkmark-white.svg" class="checkmark"/> interested</button>');
  $el.addClass('mark-interested');
  $el.attr('disabled', 'disabled');
}

/* eslint-disable no-unused-expressions */
export const myMD5 = function(d){let result = M(V(Y(X(d),8*d.length)));return result.toLowerCase()};function M(d){for(var _,m="0123456789ABCDEF",f="",r=0;r<d.length;r++)_=d.charCodeAt(r),f+=m.charAt(_>>>4&15)+m.charAt(15&_);return f}function X(d){for(var _=Array(d.length>>2),m=0;m<_.length;m++)_[m]=0;for(m=0;m<8*d.length;m+=8)_[m>>5]|=(255&d.charCodeAt(m/8))<<m%32;return _}function V(d){for(var _="",m=0;m<32*d.length;m+=8)_+=String.fromCharCode(d[m>>5]>>>m%32&255);return _}function Y(d,_){d[_>>5]|=128<<_%32,d[14+(_+64>>>9<<4)]=_;for(var m=1732584193,f=-271733879,r=-1732584194,i=271733878,n=0;n<d.length;n+=16){var h=m,t=f,g=r,e=i;f=md5_ii(f=md5_ii(f=md5_ii(f=md5_ii(f=md5_hh(f=md5_hh(f=md5_hh(f=md5_hh(f=md5_gg(f=md5_gg(f=md5_gg(f=md5_gg(f=md5_ff(f=md5_ff(f=md5_ff(f=md5_ff(f,r=md5_ff(r,i=md5_ff(i,m=md5_ff(m,f,r,i,d[n+0],7,-680876936),f,r,d[n+1],12,-389564586),m,f,d[n+2],17,606105819),i,m,d[n+3],22,-1044525330),r=md5_ff(r,i=md5_ff(i,m=md5_ff(m,f,r,i,d[n+4],7,-176418897),f,r,d[n+5],12,1200080426),m,f,d[n+6],17,-1473231341),i,m,d[n+7],22,-45705983),r=md5_ff(r,i=md5_ff(i,m=md5_ff(m,f,r,i,d[n+8],7,1770035416),f,r,d[n+9],12,-1958414417),m,f,d[n+10],17,-42063),i,m,d[n+11],22,-1990404162),r=md5_ff(r,i=md5_ff(i,m=md5_ff(m,f,r,i,d[n+12],7,1804603682),f,r,d[n+13],12,-40341101),m,f,d[n+14],17,-1502002290),i,m,d[n+15],22,1236535329),r=md5_gg(r,i=md5_gg(i,m=md5_gg(m,f,r,i,d[n+1],5,-165796510),f,r,d[n+6],9,-1069501632),m,f,d[n+11],14,643717713),i,m,d[n+0],20,-373897302),r=md5_gg(r,i=md5_gg(i,m=md5_gg(m,f,r,i,d[n+5],5,-701558691),f,r,d[n+10],9,38016083),m,f,d[n+15],14,-660478335),i,m,d[n+4],20,-405537848),r=md5_gg(r,i=md5_gg(i,m=md5_gg(m,f,r,i,d[n+9],5,568446438),f,r,d[n+14],9,-1019803690),m,f,d[n+3],14,-187363961),i,m,d[n+8],20,1163531501),r=md5_gg(r,i=md5_gg(i,m=md5_gg(m,f,r,i,d[n+13],5,-1444681467),f,r,d[n+2],9,-51403784),m,f,d[n+7],14,1735328473),i,m,d[n+12],20,-1926607734),r=md5_hh(r,i=md5_hh(i,m=md5_hh(m,f,r,i,d[n+5],4,-378558),f,r,d[n+8],11,-2022574463),m,f,d[n+11],16,1839030562),i,m,d[n+14],23,-35309556),r=md5_hh(r,i=md5_hh(i,m=md5_hh(m,f,r,i,d[n+1],4,-1530992060),f,r,d[n+4],11,1272893353),m,f,d[n+7],16,-155497632),i,m,d[n+10],23,-1094730640),r=md5_hh(r,i=md5_hh(i,m=md5_hh(m,f,r,i,d[n+13],4,681279174),f,r,d[n+0],11,-358537222),m,f,d[n+3],16,-722521979),i,m,d[n+6],23,76029189),r=md5_hh(r,i=md5_hh(i,m=md5_hh(m,f,r,i,d[n+9],4,-640364487),f,r,d[n+12],11,-421815835),m,f,d[n+15],16,530742520),i,m,d[n+2],23,-995338651),r=md5_ii(r,i=md5_ii(i,m=md5_ii(m,f,r,i,d[n+0],6,-198630844),f,r,d[n+7],10,1126891415),m,f,d[n+14],15,-1416354905),i,m,d[n+5],21,-57434055),r=md5_ii(r,i=md5_ii(i,m=md5_ii(m,f,r,i,d[n+12],6,1700485571),f,r,d[n+3],10,-1894986606),m,f,d[n+10],15,-1051523),i,m,d[n+1],21,-2054922799),r=md5_ii(r,i=md5_ii(i,m=md5_ii(m,f,r,i,d[n+8],6,1873313359),f,r,d[n+15],10,-30611744),m,f,d[n+6],15,-1560198380),i,m,d[n+13],21,1309151649),r=md5_ii(r,i=md5_ii(i,m=md5_ii(m,f,r,i,d[n+4],6,-145523070),f,r,d[n+11],10,-1120210379),m,f,d[n+2],15,718787259),i,m,d[n+9],21,-343485551),m=safe_add(m,h),f=safe_add(f,t),r=safe_add(r,g),i=safe_add(i,e)}return Array(m,f,r,i)}function md5_cmn(d,_,m,f,r,i){return safe_add(bit_rol(safe_add(safe_add(_,d),safe_add(f,i)),r),m)}function md5_ff(d,_,m,f,r,i,n){return md5_cmn(_&m|~_&f,d,_,r,i,n)}function md5_gg(d,_,m,f,r,i,n){return md5_cmn(_&f|m&~f,d,_,r,i,n)}function md5_hh(d,_,m,f,r,i,n){return md5_cmn(_^m^f,d,_,r,i,n)}function md5_ii(d,_,m,f,r,i,n){return md5_cmn(m^(_|~f),d,_,r,i,n)}function safe_add(d,_){var m=(65535&d)+(65535&_);return(d>>16)+(_>>16)+(m>>16)<<16|65535&m}function bit_rol(d,_){return d<<_|d>>>32-_}

export const startDateNoTz = (start_date) => {
  const dTimezone = new Date();
  const offset = dTimezone.getTimezoneOffset() / 60;
  const date = new Date(Date.parse(start_date));
  date.setHours(date.getHours() + offset);

  return date;
};

window.setCookie = function (name,value,days) {
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + (days*24*60*60*1000));
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "")  + expires + "; path=/";
};
window.getCookie = function (name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for(var i=0;i < ca.length;i++) {
    var c = ca[i];
    while (c.charAt(0)==' ') c = c.substring(1,c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
  }
  return null;
};
window.deleteCookie = function (name) {
  document.cookie = name+'=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
};

export const storeLastJobFilters = (filters) => {
  let newFilters = {};
  if (filters && filters.profession_id) {
    newFilters.profession_id = { ...filters.profession_id };
  }

  if (filters && filters.specialty_ids && filters.specialty_ids.length > 0) {
    newFilters.specialty_ids = [...filters.specialty_ids];
  }
  window.setCookie('lstJbSrch', JSON.stringify(newFilters));
}

export const getLastJobFilters = () => {
  const jbSrch = JSON.parse(window.getCookie('lstJbSrch'));
  if (!_.isEmpty(jbSrch)) {
    return { ...jbSrch };
  }
  return null;
}

// Extend the default Number object with a formatMoney() method:
// usage: someVar.formatMoney(decimalPlaces, symbol, thousandsSeparator, decimalSeparator)
// defaults: (2, "$", ",", ".")
export const formatMoney = function(number, places, symbol, thousand, decimal) {
  places = !isNaN(places = Math.abs(places)) ? places : 2;
  symbol = symbol !== undefined ? symbol : "$";
  thousand = thousand || ",";
  decimal = decimal || ".";
  var negative = number < 0 ? "-" : "",
    i = parseInt(number = Math.abs(+number || 0).toFixed(places), 10) + "",
    j = (j = i.length) > 3 ? j % 3 : 0;
  return symbol + negative + (j ? i.substr(0, j) + thousand : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousand) + (places ? decimal + Math.abs(number - i).toFixed(places).slice(2) : "");
};